import { Permission } from '../types';

export const PERMISSION_LABELS: Record<Permission, string> = {
  // Visualização
  [Permission.ViewDashboard]: 'Visualizar Dashboard',
  [Permission.ViewEngineeringMetrics]: 'Visualizar Métricas de Engenharia',
  [Permission.ViewReliabilityMetrics]: 'Visualizar Métricas de Confiabilidade',
  [Permission.ViewContributors]: 'Visualizar Contribuidores',
  [Permission.ViewRepositories]: 'Visualizar Repositórios',
  [Permission.ViewIncidents]: 'Visualizar Incidentes',
  [Permission.ViewPlanning]: 'Visualizar Planejamento',
  [Permission.CreatePlanning]: 'Criar Planejamento',
  [Permission.EditPlanning]: 'Editar Planejamento',
  [Permission.DeletePlanning]: 'Deletar Planejamento',
  
  // Configurações
  [Permission.ManageIntegrations]: 'Gerenciar Integrações',
  [Permission.ManageRepositories]: 'Gerenciar Repositórios',
  [Permission.ManageExtractionConfig]: 'Gerenciar Configuração de Extração',
  [Permission.ManageManualSync]: 'Gerenciar Sincronização Manual',
  
  // Gestão de Usuários
  [Permission.ViewMembers]: 'Visualizar Membros',
  [Permission.InviteMembers]: 'Convidar Membros',
  [Permission.RemoveMembers]: 'Remover Membros',
  [Permission.ChangeMemberRoles]: 'Alterar Roles de Membros',
  [Permission.AssociateGitHubAccounts]: 'Associar Contas GitHub',
  [Permission.ManagePermissions]: 'Gerenciar Permissões',
  
  // Organização
  [Permission.EditOrganization]: 'Editar Organização',
  [Permission.DeleteOrganization]: 'Deletar Organização',
  [Permission.TransferOwnership]: 'Transferir Propriedade',
  
  // Dados
  [Permission.GenerateRetroactiveHistory]: 'Gerar Histórico Retroativo',
  [Permission.ExportData]: 'Exportar Dados',
  
  // Incidentes
  [Permission.CreateIncident]: 'Criar Incidente',
  [Permission.EditIncident]: 'Editar Incidente',
  [Permission.DeleteIncident]: 'Deletar Incidente',
  [Permission.CloseIncident]: 'Fechar Incidente',
};

export const PERMISSION_CATEGORIES = {
  'Visualização': [
    Permission.ViewDashboard,
    Permission.ViewEngineeringMetrics,
    Permission.ViewReliabilityMetrics,
    Permission.ViewContributors,
    Permission.ViewRepositories,
    Permission.ViewIncidents,
    Permission.ViewPlanning,
  ],
  'Planejamento': [
    Permission.CreatePlanning,
    Permission.EditPlanning,
    Permission.DeletePlanning,
  ],
  'Configurações': [
    Permission.ManageIntegrations,
    Permission.ManageRepositories,
    Permission.ManageExtractionConfig,
    Permission.ManageManualSync,
  ],
  'Gestão de Usuários': [
    Permission.ViewMembers,
    Permission.InviteMembers,
    Permission.RemoveMembers,
    Permission.ChangeMemberRoles,
    Permission.AssociateGitHubAccounts,
    Permission.ManagePermissions,
  ],
  'Organização': [
    Permission.EditOrganization,
    Permission.DeleteOrganization,
    Permission.TransferOwnership,
  ],
  'Dados': [
    Permission.GenerateRetroactiveHistory,
    Permission.ExportData,
  ],
  'Incidentes': [
    Permission.CreateIncident,
    Permission.EditIncident,
    Permission.DeleteIncident,
    Permission.CloseIncident,
  ],
};

export function getPermissionLabel(permission: Permission): string {
  return PERMISSION_LABELS[permission] || permission;
}

export function getPermissionCategory(permission: Permission): string {
  for (const [category, permissions] of Object.entries(PERMISSION_CATEGORIES)) {
    if (permissions.includes(permission)) {
      return category;
    }
  }
  return 'Outros';
}
